module.exports = __webpack_public_path__ + "static/media/towing_services_sd.8f40132b.png";